import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type {
  GitRef,
  UpdateGitRefParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  method: 'put' | 'patch'
  params: UpdateGitRefParams | GitRef
  id: string
  onSuccess?: () => void
  children?: () => ReactElement
}

const UpdateGitConnectionRequest = ({
  method,
  params,
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${VAM_SERVICE}/repositories/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method={method}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default UpdateGitConnectionRequest
